import {SYSTEMSETTING} from 'Constants/ActionTypes';

const {
  GET_TALKING_SKILL_LIST,
  SET_TALKING_SKILL_PAGE_STATUS,
  SET_TALKING_SKILL_CONFIG_MODAL_DATA,
  GET_TALKING_SKILL_AI_APP_OPTIONS,
  GET_TALKING_SKILL_APP_CHANNEL_OPTIONS,
  GET_TASKING_SKILL_YUNWEN_CHANNELS,
  GET_TASKING_SKILL_YUNWEN_SCENES,
} = SYSTEMSETTING;

const initialState = {
  yunwenChannels:[],
  yunwenScenes:[],
  aiAppOptions: [],
  appChannelOptions: [],
  tableListData: {
    data: [],
    total: 0,
  }, // table数据
  pageStatus: {
    pageNum: 1,
    pageSize: 20,
  }, // pageNum与pageSize
  configModalData: {}, // 配置弹框的数据
};

const talkingSkill = (state = initialState, action) => {
  switch (action.type) {

    case `${GET_TASKING_SKILL_YUNWEN_CHANNELS}_SUCCESS`:
      return {
        ...state,
        yunwenChannels: action.payload.data,
      };
    case `${GET_TASKING_SKILL_YUNWEN_SCENES}_SUCCESS`:
      return {
        ...state,
        yunwenScenes: action.payload.data,
      };
    case `${GET_TALKING_SKILL_AI_APP_OPTIONS}_SUCCESS`:
      return {
        ...state,
        aiAppOptions: action.payload.data,
      };
    case `${GET_TALKING_SKILL_APP_CHANNEL_OPTIONS}_SUCCESS`:
      return {
        ...state,
        appChannelOptions: action.payload.data,
      };
    case `${GET_TALKING_SKILL_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.list) || [],
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    case `${GET_TALKING_SKILL_LIST}_FAIL`:
      return {
        ...state,
        tableListData: {
          data: [],
          total: 0,
        },
      };
    case `${SET_TALKING_SKILL_PAGE_STATUS}`:
      return {
        ...state,
        pageStatus: {...state.pageStatus, ...action.data},
      };
    case `${SET_TALKING_SKILL_CONFIG_MODAL_DATA}`:
      return {
        ...state,
        configModalData: action.data,
      };
    default:
      return state;
  }
};

export default talkingSkill;
